module.exports = __webpack_public_path__ + "static/paulBig-12e5ff13357d87b2bd70342ebfced3d2.png";